import { TypeAnimation } from 'react-type-animation';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

import { FadeInOnView, ShareButton } from '@app/shared/ui/atoms/Common';
import { ListItem } from '@app/shared/ui/molecules/DailyCardResult';
import { ADVICE_ICONS } from '@app/shared/constants/dailyCardResult';
import { Advice } from '@app/shared/types/pages/dailyCardResult';

interface AdvicesSectionProps {
  cardName?: string;
  advices: Advice[];
}

export function AdvicesSection({ cardName, advices }: AdvicesSectionProps) {
  const { t } = useTranslation();
  const sectionEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (sectionEndRef.current) {
        sectionEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 1700);

    return () => clearTimeout(timeout);
  }, [advices]);

  return (
    <section className="mt-6 flex flex-col gap-6">
      {cardName && (
        <TypeAnimation
          sequence={[`${t('daily_card_result.your_card_of_the_day')} - ${cardName}`]}
          wrapper="h3"
          speed={{ type: 'keyStrokeDelayInMs', value: 25 }}
          cursor={false}
          className="text-xl font-semibold"
        />
      )}

      <div className="flex flex-col gap-3.5">
        {advices.map((item, idx) => (
          <FadeInOnView key={`${item.title}__${idx}`}>
            <ListItem
              icon={ADVICE_ICONS[idx % ADVICE_ICONS.length]}
              title={item.title}
              description={item.description}
            />
          </FadeInOnView>
        ))}
      </div>

      <div ref={sectionEndRef}>
        <ShareButton />
      </div>
    </section>
  );
}
